import React from "react";
import { useTranslation } from "react-i18next";
import { Box, styled, Unstable_Grid2 as Grid } from "@mui/material";
import { useSelector } from 'react-redux';

const Title = styled("h2")(({ theme }) => ({
  fontFamily: "Patua One",
  fontSize: "23px",
  fontWeight: 400,
  lineHeight: "28.04px",
  textAlign: "center",
  marginBottom: "1.2rem",
  [theme.breakpoints.up("sm")]: {
    fontSize: "26px",
    lineHeight: "32.57px",
  },
}));

const TextHeader = styled("strong")(({ theme }) => ({
  display: "block",
  fontFamily: "Roboto",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "14.06px",
  mb: 0,
  color: "#2287B8",
  [theme.breakpoints.up("sm")]: {
    fontSize: "16px",
    lineHeight: "18.75px",
  },
}));

const TextItem = styled("span")(({ theme }) => ({
  display: "block",
  fontFamily: "Roboto",
  fontSize: "11px",
  fontWeight: 400,
  lineHeight: "14px",
  color: "#64748B",
  [theme.breakpoints.up("sm")]: {
    fontSize: "16px",
    lineHeight: "18.75px",
  },
}));

const TextPrice = styled("strong")(({ theme }) => ({
  display: "block",
  fontFamily: "Patua One",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "14.63px",
  color: "#191D23",
  [theme.breakpoints.up("sm")]: {
    fontSize: "16px",
    lineHeight: "19.5px",
  },
}));

const TextSubtotal = styled("span")(({ theme }) => ({
  display: "block",
  fontFamily: "Roboto",
  fontSize: "11px",
  fontWeight: 400,
  lineHeight: "13.2px",
  mb: 0,
  color: "#191D23",
  [theme.breakpoints.up("sm")]: {
    fontSize: "16px",
    lineHeight: "19.2px",
  },
}));

const TextTotal = styled("strong")(({ theme }) => ({
  display: "block",
  fontFamily: "Patua One",
  fontSize: "18px",
  fontWeight: 400,
  lineHeight: "21.94px",
  color: "#191D23",
  [theme.breakpoints.up("sm")]: {
    fontSize: "24px",
    lineHeight: "29.26px",
  },
}));

const ItemLeft = ({ children }) => (
  <Grid xs={7} sm={8} md={7}>
    {children}
  </Grid>
);
const ItemRight = ({ children }) => (
  <Grid xs={5} sm={4} md={5} sx={{ textAlign: "right" }}>
    {children}
  </Grid>
);

const Separate = styled(Grid)(({ theme }) => ({
  height: "1rem",
  width: "100%",
  marginBottom: 8,
  [theme.breakpoints.up("md")]: {
    height: "1.2rem",
    marginBottom: 16,
  },
}));

const DetailsInvoice = ({ transaction = [] }) => {
  const { t } = useTranslation();
  const currency = useSelector((state) => state.global.currency);

  return (
    <Box sx={{ borderRadius: 2, backgroundColor: "#F0F7FA", p: 2, minHeight: { md: "400px" }, marginTop: { md: "2.5rem" } }}>
      <Title>{t("ppp.details_invoice.title")}</Title>

      <Grid container>
        <ItemLeft>
          <TextHeader>{t("ppp.details_invoice.table.header_left")}</TextHeader>
        </ItemLeft>
        <ItemRight>
          <TextHeader>{t("ppp.details_invoice.table.header_right")}</TextHeader>
        </ItemRight>

        <Separate />

        {/* items */}
        {transaction.item_list.items.map((item, index) => (
          <React.Fragment key={index}>
            <ItemLeft>
              <TextItem>{item.description}</TextItem>
            </ItemLeft>
            <ItemRight>
              <TextPrice>
                $ {item.price} {item.currency}
              </TextPrice>
            </ItemRight>
          </React.Fragment>
        ))}

        <Separate sx={{ borderBottom: "1px solid #46AA71" }} />
        {/* subtotal */}
        <ItemLeft>
          <TextSubtotal>{t("ppp.details_invoice.table.subtotal")}</TextSubtotal>
        </ItemLeft>
        <ItemRight>
          <TextPrice>$ {transaction.amount ? transaction.amount.details.subtotal + " " + transaction.amount.currency : `0.00 ${currency}`}</TextPrice>
        </ItemRight>

        <Separate sx={{ height: 2, mb: "0!important" }} />

        {/* IVA */}
        <ItemLeft>
          <TextSubtotal>{t("ppp.details_invoice.table.iva")}</TextSubtotal>
        </ItemLeft>
        <ItemRight>
          <TextPrice>$ {transaction.amount ? transaction.amount.details.tax + " " + transaction.amount.currency : `0.00 ${currency}`}</TextPrice>
        </ItemRight>

        <Separate sx={{ borderTop: "1px solid #46AA71", mt: 1 }} />

        {/* total */}
        <ItemLeft>
          <TextTotal>{t("ppp.details_invoice.table.total")}</TextTotal>
        </ItemLeft>
        <ItemRight>
          <TextTotal>$ {transaction.amount ? transaction.amount.total + " " + transaction.amount.currency : `0.00 ${currency}`}</TextTotal>
        </ItemRight>
      </Grid>
    </Box>
  );
};

export default DetailsInvoice;
